import { ActionType } from 'typesafe-actions';
import BaseReducer, {
	baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import { IProductGroupType } from '../../types/IProductGroupType';
import * as productGroupActions from './productGroupActions';

export type ProductGroupAction = ActionType<typeof productGroupActions>;

export interface IProductGroupStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IProductGroupType };
	readonly queries: { [queryKey: string]: IProductGroupType[] };
}

export function productGroupReducer(
	state = baseInitialState as IProductGroupStateType,
	action: ProductGroupAction,
) {
	const Reducer = new BaseReducer('productGroupReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			default:
				return innerState;
		}
	});
}
